import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ecc9565a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ecc9565a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc9565a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecc9565a')) {
      api.createRecord('ecc9565a', component.options)
    } else {
      api.reload('ecc9565a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ecc9565a&scoped=true&", function () {
      api.rerender('ecc9565a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dcuZ8QvOZUD2/JS/comp/PopupBox.vue"
export default component.exports